import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AppointmentModal from './components/AppointmentModal';
import ThankYouModal from './components/ThankYouModal';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Disclaimer from './pages/Disclaimer';
import './App.css';

function App() {
  const [showModal, setShowModal] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const handleSuccess = () => {
    setShowModal(false);
    setShowThankYou(true);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar openModal={openModal} />
        <main>
          <Routes>
            <Route
              path="/"
              element={<Home openModal={openModal} handleSuccess={handleSuccess} />}
            />
            <Route
              path="/privacy-policy"
              element={<PrivacyPolicy openModal={openModal} />}
            />
            <Route
              path="/terms-and-conditions"
              element={<TermsConditions openModal={openModal} />}
            />
            <Route
              path="/terms"
              element={<TermsConditions openModal={openModal} />}
            />
            <Route
              path="/disclaimer"
              element={<Disclaimer openModal={openModal} />}
            />
            <Route
              path="*"
              element={<Home openModal={openModal} handleSuccess={handleSuccess} />}
            />
          </Routes>
        </main>
        <Footer openModal={openModal} />

        {showModal && (
          <AppointmentModal closeModal={closeModal} onSuccess={handleSuccess} />
        )}
        {showThankYou && (
          <ThankYouModal close={() => setShowThankYou(false)} />
        )}
      </div>
    </Router>
  );
}

export default App;
